import React, { useEffect, useState } from "react";

import { Grid, TextField, Box, Button } from "@mui/material";

import axiosClient from "../axiosClient";

import { useNavigate } from "react-router-dom";

import { useStateContext } from "../context/ContextProvider";

const StoreDetailsScreen = () => {
  const { store, setStore } = useStateContext();

  const [name, setName] = useState();
  const [address, setAddress] = useState();
  const [zip, setZip] = useState();
  const [telephone, setTelephone] = useState();

  const navigate = useNavigate();

  const [preview, setPreview] = useState(null);
  const [change, onChange] = useState(null);

  const handleChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
        onChange(file);
      };
      reader.readAsDataURL(file);
    }
  };

  useEffect(() => {
    const correctStoreName = JSON.parse(store).name.replace(/[^a-zA-Z]/g, "");
    const databaseStoreName = `DB301_${
      JSON.parse(store).id
    }_${correctStoreName}`;

    setName(JSON.parse(store).name);
    setAddress(JSON.parse(store).address);
    setZip(JSON.parse(store).zip);
    setTelephone(JSON.parse(store).telephone);
    if (JSON.parse(store).logo != null) {
      setPreview(
        `${process.env.REACT_APP_PHOTO_URL}${databaseStoreName}/${
          JSON.parse(store).logo
        }${JSON.parse(store).id}.jpg`
      );
    }
  }, [store]);

  const changeDetails = () => {
    const correctStoreName = JSON.parse(store).name.replace(/[^a-zA-Z]/g, "");
    const databaseStoreName = `DB301_${
      JSON.parse(store).id
    }_${correctStoreName}`;

    var base64Data;
    var binaryData;

    if (preview === null || preview === undefined) {
      base64Data = null;
      binaryData = null;
    } else if (
      typeof preview === "string" &&
      !preview.includes("data:image/jpeg;base64,")
    ) {
      base64Data = "";
      binaryData = "";
    } else {
      base64Data = preview?.split(",")[1]; // Extract the Base64 data
      binaryData = atob(base64Data);
    }

    const payload = {
      params: {
        companyId: JSON.parse(store).CompanyId,
        storeId: JSON.parse(store).id,
        storeName: name,
        databaseName: databaseStoreName,
        address: address,
        zip: zip,
        telephone: telephone,
        logo: binaryData,
      },
    };
    axiosClient
      .patch("customer/company/store", payload)
      .then((response) => {
        const store_new = JSON.parse(store);
        store_new["name"] = name;
        store_new["address"] = address;
        store_new["zip"] = zip;
        store_new["telephone"] = telephone;
        store_new["logo"] = response.data.logo_url;
        setStore(JSON.stringify(store_new));
        window.location.reload();
      })
      .catch((err) => console.log(err));
  };

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={12} lg={6} md={6} sm={6}>
          <TextField
            InputLabelProps={{ shrink: true }}
            label="Name"
            disabled
            fullWidth
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} lg={6} md={6} sm={6}>
          <TextField
            InputLabelProps={{ shrink: true }}
            label="Address"
            fullWidth
            value={address}
            onChange={(e) => setAddress(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} lg={6} md={6} sm={6}>
          <TextField
            InputLabelProps={{ shrink: true }}
            label="Zip"
            fullWidth
            value={zip}
            onChange={(e) => setZip(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} lg={6} md={6} sm={6}>
          <TextField
            InputLabelProps={{ shrink: true }}
            label="Telephone"
            fullWidth
            value={telephone}
            onChange={(e) => setTelephone(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} lg={6} md={6} sm={6}>
          <div className="image-input-container">
            <input
              type="file"
              accept=".jpg"
              onChange={handleChange}
              className="input-file"
            />
            {preview && (
              <img src={preview} alt="Preview" className="preview-image" />
            )}
            {!preview && (
              <div className="placeholder">Click to select an image</div>
            )}
          </div>
        </Grid>
      </Grid>
      <Box m={3} />

      <Grid container spacing={2}>
        <Grid
          item
          xs={12}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: 16,
          }}
        >
          <Button
            variant="contained"
            color="success"
            style={{ marginRight: 16, marginLeft: 16 }}
            onClick={changeDetails}
          >
            Change details
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={() => navigate("/")}
          >
            Cancel
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

export default StoreDetailsScreen;
